import * as React from 'react';

function SvgProcessArrow(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 12" {...props}>
      <path
        d="M1.478.192l.069.06 5.435 5.142a.824.824 0 01.059 1.15l-.059.062-5.435 5.143a.943.943 0 01-1.282 0 .824.824 0 01-.058-1.151l.058-.061L5.06 6 .265 1.463a.825.825 0 010-1.212.944.944 0 011.213-.059zm7.805 0l.068.06 5.436 5.142a.824.824 0 01.059 1.15l-.06.062-5.435 5.143a.943.943 0 01-1.28 0 .824.824 0 01-.06-1.151l.06-.061L12.864 6 8.07 1.463a.825.825 0 010-1.212.944.944 0 011.213-.059zm7.804 0l.07.06 5.435 5.142a.824.824 0 01.059 1.15l-.06.062-5.435 5.143a.943.943 0 01-1.28 0 .824.824 0 01-.06-1.151l.06-.061L20.67 6l-4.795-4.537a.825.825 0 010-1.212.944.944 0 011.212-.059z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgProcessArrow;
